import { Injectable } from "@angular/core";
import { HttpHelperService } from "@services/http-helper.service";
import {
  AgentDetail,
  EStatementAgentPayload,
  EStatementDownloadPayload,
  EStatementDownloadResponse,
  EStatementLov,
} from "@shared/interfaces/e-statement";
import { Observable } from "rxjs";

@Injectable()
export class EStatementService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public postAgentDetail(
    body: EStatementAgentPayload,
  ): Observable<{ data: AgentDetail }> {
    return this.httpHelperService.post(`/home/agent/detail`, body);
  }

  public getEstatementLov(userId: string): Observable<EStatementLov> {
    return this.httpHelperService.get(
      `/users/estatements/lov?userId=${userId}`,
    );
  }

  public getUserBranchList(userId: string): Observable<{
    data: {
      userBranchList: import("@shared/interfaces/profile.model").BranchItem[];
    };
  }> {
    return this.httpHelperService.get(
      `/home/lov/type?userId=${userId}&listType=userBranchList`,
    );
  }

  public getEStatementYearList(
    userId: string,
  ): Observable<{ estatemtYearList: string[] }> {
    return this.httpHelperService.get(
      `/home/estatement/yearlist?userId=${userId}`,
    );
  }

  public getUserAgentList(userId: string): Observable<{
    data: {
      agentList: import("@shared/interfaces/profile.model").ELearningAgent[];
    };
  }> {
    return this.httpHelperService.get(`/home/agents?userId=${userId}`);
  }

  public getAgentList(body: EStatementAgentPayload): Observable<{
    data: {
      agentList: import("@shared/interfaces/profile.model").ELearningAgent[];
    };
  }> {
    return this.httpHelperService.post(`/home/agents/`, body);
  }

  public downloadCP58(
    body: EStatementDownloadPayload,
  ): Observable<EStatementDownloadResponse> {
    return this.httpHelperService.get(
      `/report/download/cp58?agentCode=${body.agentCode}&year=${body.year}`,
    );
  }

  public downloadCP58Success(body: EStatementDownloadPayload): void {
    window.location.assign(
      this.httpHelperService.getURLString(
        `/report/download/cp58?agentCode=${body.agentCode}&year=${body.year}`,
      ),
    );
  }

  public downloadProfitCommSuccess(body: EStatementDownloadPayload): void {
    window.location.assign(
      this.httpHelperService.getURLString(
        `/report/download/profitcomm?agentCode=${body.agentCode}&year=${body.year}`,
      ),
    );
  }

  public downloadProfitComm(
    body: EStatementDownloadPayload,
  ): Observable<EStatementDownloadResponse> {
    return this.httpHelperService.get(
      `/report/download/profitcomm?agentCode=${body.agentCode}&year=${body.year}`,
    );
  }
}
